import { createAsyncThunk } from "@reduxjs/toolkit";

import coreAPIs from "../../../services/api/core";

export const getNotifications = createAsyncThunk("core/notifications/getNotifications", async (payload) => {
  try {
    const response = await coreAPIs.getNotifications(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const addNewNotification = createAsyncThunk(
  "core/notifications/addNewNotification",
  async (notificationData) => {
    try {
      return notificationData;
    } catch (error) {
      console.error("Error adding notification:", error);
      throw error;
    }
  },
);
